import Alpine from "alpinejs";

export function waitForAlpineStore(storeName, interval = 50, timeout = 5000) {
  return new Promise((resolve, reject) => {
    const start = Date.now();

    const check = () => {
      if (Alpine.store(storeName)) {
        resolve(Alpine.store(storeName));
      } else if (Date.now() - start > timeout) {
        reject(new Error(`Alpine store "${storeName}" did not appear within ${timeout}ms`));
      } else {
        setTimeout(check, interval);
      }
    };

    check();
  });
}